document.documentElement.classList.remove('no-js');
for (const section of document.querySelectorAll('[data-product-section]')) {
  const variantsElement = section.querySelector('[data-variants]');
  const select = section.querySelector('[data-variant-select]');
  if (variantsElement && select) {
    const variants = JSON.parse(variantsElement.textContent);
    const format = new Intl.NumberFormat(section.dataset.locale || 'en-US', {style: 'currency', currency: section.dataset.currency || 'USD'});
    const price = section.querySelector('[data-product-price]');
    const msrp = section.querySelector('[data-product-msrp]');
    const compare = section.querySelector('[data-compare-price]');
    const savings = section.querySelector('[data-product-savings]');
    const button = section.querySelector('.product-submit');
    const submitLabel = section.querySelector('[data-submit-label]');
    select.addEventListener('change', () => {
      const variant = variants.find(item => String(item.id) === select.value);
      if (!variant) return;
      if (price) price.textContent = format.format(variant.price / 100);
      const hasSavings = variant.compare_at_price > variant.price;
      if (msrp) msrp.hidden = !hasSavings;
      if (compare) compare.textContent = format.format((variant.compare_at_price || 0) / 100);
      if (savings) {
        savings.hidden = !hasSavings;
        if (hasSavings) savings.textContent = savings.dataset.saveTemplate.replace('__AMOUNT__', format.format((variant.compare_at_price - variant.price) / 100));
      }
      if (button) button.disabled = !variant.available;
      if (submitLabel) submitLabel.textContent = variant.available ? section.dataset.submitAvailable : section.dataset.submitUnavailable;
      const next = new URL(window.location.href);
      next.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', next);
      if (variant.featured_image) {
        const image = section.querySelector('.gallery-main');
        if (image) {image.src = variant.featured_image.src; image.removeAttribute('srcset');}
      }
    });
  }
  for (const thumb of section.querySelectorAll('[data-gallery-src]')) {
    thumb.addEventListener('click', () => {
      const stage = section.querySelector('.gallery-main');
      if (!stage) return;
      stage.src = thumb.dataset.gallerySrc;
      stage.alt = thumb.dataset.galleryAlt;
      stage.removeAttribute('srcset');
      for (const peer of section.querySelectorAll('[data-gallery-src]')) peer.setAttribute('aria-pressed', String(peer === thumb));
    });
  }
}
for (const nav of document.querySelectorAll('.mobile-nav')) {
  for (const link of nav.querySelectorAll('a')) link.addEventListener('click', () => nav.removeAttribute('open'));
}
if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) {entry.target.classList.add('is-visible');observer.unobserve(entry.target);}
  }, {threshold: 0.08});
  for (const element of document.querySelectorAll('.reveal')) {element.classList.add('will-reveal');observer.observe(element);}
}
